import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import registerServiceWorker from '../registerServiceWorker';
import Wix from 'Wix';
import store from '../store';
import { Provider } from 'react-redux';
import { IntlProvider, addLocaleData } from "react-intl";
import SettingsRoutes from '../settings/routes';
import locale from '../utils/locale.widget';

require('./widget.scss');

window.store = store;
//const lang = Wix.Utils.getLocale() || 'en';
//const translations = require(`./translations/${lang}`);
//const locale = require(`react-intl/locale-data/${lang}`);


addLocaleData(locale.locale);
Sentry.init({dsn: "https://b06ad2df283b44bcaf66356449caa3ed@sentry.wixpress.com/260"});

ReactDOM.render(
    <Provider store={store}>
        <IntlProvider locale={locale.lang} messages={locale.translations}>
            <SettingsRoutes />
        </IntlProvider>
    </Provider>
    , document.getElementById('root'));
registerServiceWorker();






// WEBPACK FOOTER //
// ./src/widget/widget_main.js